import { createDataGridFilter } from '../create-data-grid-filter';
import {
  createOneOfFilterModel,
  OneOfFilterModel,
  oneOfFilterModelName,
  OneOfFilterParams,
} from './core';
import { OneOfFilterComponent } from './one-of-filter.component';

export const OneOfFilterDataGrid = createDataGridFilter<
  OneOfFilterModel,
  OneOfFilterParams
>((params) => ({
  modelName: oneOfFilterModelName,
  modelFactory: createOneOfFilterModel,
  component: (props) => (
    <OneOfFilterComponent {...props} filterParams={params} />
  ),
}));

export type OneOfFilterDataGridComponent = ReturnType<
  typeof OneOfFilterDataGrid
>;
